import { isMobile } from '@/lib/device'
import i18n from '@/lib/language'
export default [
  {
    path: '/account',
    name: 'AccountLayout',
    props: true,
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/components/mobile/OrgLayout`)
        : import(/* webpackChunkName: "pc-base" */ `@/components/pc/OrgLayout`),
    /* redirect: () => {
      return {
        name: 'AccountInfo'
      }
    }, */
    children: [
      {
        path: '/',
        name: 'AccountList',
        component: () =>
          isMobile
            ? import(/* webpackChunkName: "mb-base" */ `@/mobile/account/AccountInfo`)
            : import(/* webpackChunkName: "pc-base" */ `@/pc/account/accountList/AccountList`),
        children: [{
          path: 'accountinfo',
          name: 'AccountInfo',
          component: () =>
            isMobile
              ? import(/* webpackChunkName: "mb-base" */ `@/mobile/account/AccountInfo`)
              : import(/* webpackChunkName: "pc-base" */ `@/pc/account/accountList/AccountInfo`)
        }, {
          path: 'loginlog',
          name: 'AccountLoginLog',
          component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/account/accountList/Log`)
        },
        {
          path: 'order',
          name: 'AccountOrder',
          component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/account/accountList/Order`)
        },
        {
          path: 'invoice',
          name: 'AccountInvoice',
          component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/account/accountList/Invoice`)
        },
        {
          path: 'maillist',
          name: 'AccountMailList',
          component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/account/accountList/StationMail`)
        }]
      },
      {
        path: 'invoiceapply',
        name: 'ApplyInvoice',
        component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/account/ApplyInvoice`)
      },
      {
        path: 'setaccount',
        name: 'PersonAcount',
        component: () =>
          isMobile
            ? import(/* webpackChunkName: "mb-base" */ `@/mobile/account/personInfo/setAccount`)
            : import(/* webpackChunkName: "pc-base" */ `@/pc/account/personInfo/setAccount`),
        meta: {
          title: i18n.t('message["1381"]')
        }
      },
      {
        path: 'modifypwd',
        name: 'PersonPassword',
        component: () =>
          isMobile
            ? import(/* webpackChunkName: "mb-base" */ `@/mobile/account/personInfo/setPassword`)
            : import(/* webpackChunkName: "pc-base" */ `@/pc/account/personInfo/setPassword`),
        meta: {
          title: i18n.t('message["1381"]')
        }
      },
      {
        path: 'setphone',
        name: 'PersonPhone',
        component: () =>
          isMobile
            ? import(/* webpackChunkName: "mb-base" */ `@/mobile/account/personInfo/setPhone`)
            : import(/* webpackChunkName: "pc-base" */ `@/pc/account/personInfo/setPhone`),
        meta: {
          title: i18n.t('message["1381"]')
        }
      },
      {
        path: 'modifyphone',
        name: 'ModifyPhone',
        component: () =>
          isMobile
            ? import(/* webpackChunkName: "mb-base" */ `@/mobile/account/personInfo/changePhone`)
            : import(/* webpackChunkName: "pc-base" */ `@/pc/account/personInfo/changePhone`),
        meta: {
          title: i18n.t('message["1381"]')
        }
      },
      {
        path: 'setemail',
        name: 'SetEmail',
        component: () =>
          isMobile
            ? import(/* webpackChunkName: "mb-base" */ `@/mobile/account/personInfo/setEmail`)
            : import(/* webpackChunkName: "pc-base" */ `@/pc/account/personInfo/setEmail`),
        meta: {
          title: i18n.t('message["1381"]')
        }
      },
      {
        path: 'modifyemail',
        name: 'ModifyEmail',
        component: () =>
          isMobile
            ? import(/* webpackChunkName: "mb-base" */ `@/mobile/account/personInfo/modifyEmail`)
            : import(/* webpackChunkName: "pc-base" */ `@/pc/account/personInfo/modifyEmail`),
        meta: {
          title: i18n.t('message["1381"]')
        }
      }

    ]
  },
  {
    path: '/account/login',
    name: 'AccountLogin',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/account/Login`)
        : import(/* webpackChunkName: "pc-base" */ `@/pc/account/Login`),
    meta: {
      title: i18n.t('message["1381"]')
    }
  },
  {
    path: '/account/register',
    name: 'AccountRegister',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/account/Register`)
        : import(/* webpackChunkName: "pc-base" */ `@/pc/account/Register`),
    meta: {
      title: i18n.t('message["1381"]')
    }
  },
  {
    path: '/account/normaltip',
    name: 'AccountDingDing',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/account/DingDingTip`)
        : import(/* webpackChunkName: "pc-base" */ `@/pc/account/DingDingTip`),
    meta: {
      title: '星轨询盘管理'
    }
  },
  {
    path: '/account/setuser',
    name: 'AccountSetUser',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/account/RegSetUser`)
        : import(/* webpackChunkName: "pc-base" */ `@/pc/account/RegSetUser`),
    meta: {
      title: i18n.t('message["1381"]')
    }
  },
  {
    path: '/api',
    name: 'Api',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/account/Api`)
  },
  {
    path: '/merge',
    name: 'Merge',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/account/Merge`)
  },
  {
    path: '/account/findpwd',
    name: 'AccountFindPwd',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/account/FindPwd`)
        : import(/* webpackChunkName: "pc-base" */ `@/pc/account/FindPwd`),
    meta: {
      title: i18n.t('message["1381"]')
    }
  },
  {
    path: '/account/findpwdsuc',
    name: 'AccountFindPwdSuc',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/account/FindPwdSuc`),
    meta: {
      title: i18n.t('message["1381"]')
    }
  },
  {
    path: '/account/bindqwsuc',
    name: 'AccountBindQwSuc',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/account/BindQwSuc`),
    meta: {
      title: i18n.t('message["1381"]')
    }
  },
  {
    path: '/account/setuser',
    name: 'AccountSetUser',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/account/RegSetUser`)
        : import(/* webpackChunkName: "pc-base" */ `@/pc/account/RegSetUser`),
    meta: {
      title: i18n.t('message["1381"]')
    }
  }
]
